export default function Pagination({ totalPages, currentPage, handlePageClick }) {
    // ensure valid integer
    const pages = Number.isInteger(totalPages) && totalPages > 0 ? totalPages : 1;
  
    if (pages <= 1) return null; // no pagination needed
  
    // calculate visible page range
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(pages, currentPage + 2);
    const visiblePages = [];
  
    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }
  
    return (
      <div className="flex items-center justify-center space-x-2 my-6 font-monteserrat">
        {/* Previous Button */}
        <button
          onClick={() => currentPage > 1 && handlePageClick(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded-md text-sm font-medium bg-transparent shadow-none
            ${
              currentPage === 1
                ? "text-gray cursor-not-allowed"
                : "text-gray "
            }`}
        >
          Previous
        </button>
  
        {/* First Page + Ellipsis */}
        {startPage > 1 && (
          <>
            <button
              onClick={() => handlePageClick(1)}
              className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-medium 
                ${currentPage === 1 ? "bg-emerald-600 text-white" : "bg-gray-border text-gray hover:bg-gray-300"}`}
            >
              1
            </button>
            {startPage > 2 && <span className="px-2">...</span>}
          </>
        )}
  
        {/* Visible Page Numbers */}
        {visiblePages.map((page) => (
          <button
            key={page}
            onClick={() => handlePageClick(page)}
            className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-medium 
              ${
                page === currentPage
                  ? "bg-emerald-600 text-white"
                  : "bg-gray-border text-gray hover:bg-gray-300"
              }`}
          >
            {page}
          </button>
        ))}
  
        {/* Last Page + Ellipsis */}
        {endPage < pages && (
          <>
            {endPage < pages - 1 && <span className="px-2">...</span>}
            <button
              onClick={() => handlePageClick(pages)}
              className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-medium 
                ${currentPage === pages ? "bg-emerald-600 text-white" : "bg-gray-border text-gray hover:bg-gray-300"}`}
            >
              {pages}
            </button>
          </>
        )}
  
        {/* Next Button */}
        <button
          onClick={() =>
            currentPage < pages && handlePageClick(currentPage + 1)
          }
          disabled={currentPage === pages}
          className={`px-3 py-1 rounded-md text-sm font-medium bg-transparent shadow-none
            ${
              currentPage === pages
                ? "text-gray cursor-not-allowed"
                : "text-gray hover:text-gray-900"
            }`}
        >
          Next
        </button>
      </div>
    );
  }
  